import { render, staticRenderFns } from "./ViewRecord.vue?vue&type=template&id=315102fc"
import script from "./ViewRecord.vue?vue&type=script&lang=js"
export * from "./ViewRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports